import { FontItem, HistoryItem, GridType } from '../types';

const KEYS = {
  HISTORY: 'hzhandwriting_history',
  FONTS: 'hzhandwriting_fonts',
  TEXT: 'hzhandwriting_text',
  COLS: 'hzhandwriting_cols',
  GRID_TYPE: 'hzhandwriting_grid_type',
  CURRENT_FONT_ID: 'hzhandwriting_current_font_id',
} as const;

function safeGet<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

function safeSet(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // storage full or unavailable — silently ignore
  }
}

// ── History ──────────────────────────────────────────────

const DEFAULT_HISTORY: HistoryItem[] = [
  { text: '天地玄黄宇宙洪荒', label: '千字文' },
  { text: '赵钱孙李周吴郑王', label: '百家姓' },
  { text: '人之初性本善', label: '三字经' },
  { text: '自强不息厚德载物', label: '清华校训' },
  { text: '道可道非常道名可名非常名', label: '道德经' },
  { text: '一是我的了', label: '高频字' },
  { text: '他们有人不在时到这个上来', label: '高频字2' },
  { text: '一二三四五六七八九十', label: '中文数字' },
  { text: '杨译然', label: '杨译然' },
];

export function getHistory(): HistoryItem[] {
  return safeGet(KEYS.HISTORY, DEFAULT_HISTORY);
}

export function setHistory(items: HistoryItem[]): void {
  safeSet(KEYS.HISTORY, items);
}

// ── Fonts ────────────────────────────────────────────────

export function getFonts(): FontItem[] {
  return safeGet(KEYS.FONTS, []);
}

export function setFonts(fonts: FontItem[]): void {
  safeSet(KEYS.FONTS, fonts);
}

export function getCurrentFont(fonts: FontItem[]): FontItem | null {
  const id = safeGet<string | null>(KEYS.CURRENT_FONT_ID, null);
  if (!id) return null;
  return fonts.find((f) => f.id === id) || null;
}

export function setCurrentFont(fontId: string): void {
  safeSet(KEYS.CURRENT_FONT_ID, fontId);
}

// ── Text ─────────────────────────────────────────────────

export function getText(): string {
  return safeGet(KEYS.TEXT, '');
}

export function setText(text: string): void {
  safeSet(KEYS.TEXT, text);
}

// ── Cols ─────────────────────────────────────────────────

export function getCols(): number {
  return safeGet(KEYS.COLS, 3);
}

export function setCols(cols: number): void {
  safeSet(KEYS.COLS, cols);
}

// ── Grid type ────────────────────────────────────────────

export function getGridType(): GridType | null {
  return safeGet(KEYS.GRID_TYPE, null);
}

export function setGridType(type: GridType): void {
  safeSet(KEYS.GRID_TYPE, type);
}
